import React from "react";
import { useLocation, Link } from "react-router-dom";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import logoHeader from '../assets/img/preSavremena_SOS.svg';
import akreditacije from '../assets/img/Camb_mpn.webp';
import logoHeaderWhite from '../assets/img/logo_sos_sg_white_co.svg';
import bacground_mob from '../assets/img/pepper-hero-background-mob_1.jpg';

export default function Delivery() {
  const { state } = useLocation();
  const pdfLink = state?.pdfLink;
  const remaining = state?.remaining;
  const generatedCount = state?.generatedCount;

  return (
    <>
    <div className="delivery-hero">
      <div className="navbar">
        <img src={logoHeader} alt="logoSOS" className='logoHeader'/>
        <img src={akreditacije} alt="akreditacije" className='akreditacije'/>
      </div>
    <div className="page-content">
      <div className="tagname">
        <h1 className="">Vaša analiza</h1>
        {pdfLink ? (
        <>
          <div className="download-btn">
            <a href={pdfLink} target="_blank" rel="noreferrer">
            <CloudDownloadIcon className="icon icon--pulse icon--cloud" aria-hidden />
            <span>Preuzmi PDF</span></a>
          </div>
          {typeof remaining === "number" && remaining === 1 && (
            // <p>{remaining === 1
            //   ? "Ostao vam je još jedan pokušaj."
            //   : `Preostalo pokušaja: ${remaining}.`}
            // </p>
            <h2 className="basic">Ostao vam je još jedan pokušaj.</h2>
          )}
          {typeof generatedCount === "number" && (
            <p className="additional-info">Za razgovor sa našim timom i za dodatne informacije pozovite nas <a href="tel:+381114011222">011/40-11-222</a>, ili posetite <a href="www.savremena-osnovna.edu.rs">www.savremena-osnovna.edu.rs</a></p>
          )}
        </>
        ) : (
          <>
          <h2 className="basic">PDF link nije dostupan</h2>
          <p className="additional-info">Za razgovor sa našim timom i za dodatne informacije pozovite nas <a href="tel:+381114011222">011/40-11-222</a>, ili posetite <a href="www.savremena-osnovna.edu.rs">www.savremena-osnovna.edu.rs</a></p>
          </>
        )}

        <p className="link-back">
        <Link to="/"><ArrowBackIcon className="icon icon--pulse icon--back" aria-hidden />Nazad</Link>
        </p>
      </div>
      <img src={bacground_mob} alt="" />
    </div>
    </div>
    <div className="cta-section">
      <div className="cta-box">
        <h1>Upis je u toku!<br/> Stvarno drugačije obrazovanje za generacije koje menjaju svet.<br/> <a href="https://www.savremena-osnovna.edu.rs/prijava/">Prijavite se →</a></h1>
      </div>
    </div>
    <div className="footer">
      <div className="logo-box">
        <img src={logoHeaderWhite} alt="" />
      </div>
      <div className="info">
        <span>Bulevar heroja sa Košara 17,</span>
        <span>Novi Beograd</span>
        <span><a href="tel:+381114011222">011/40-11-222</a></span>
        <span><a href="tel:+381621918056">062/19-18-056</a></span>
        <span><a href="email:office@savremena-osnovna.edu.rs">office@savremena-osnovna.edu.rs</a></span>
        <span><a href="savremena-osnovna.edu.rs">savremena-osnovna.edu.rs</a></span>
      </div>
    </div>
    </>
  );
}
